import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import BookingDetails from './BookingDetails';

/**
 * BookingDetailsModal - Mobile modal showing full booking details
 * Wrapper around BookingDetails component with modal variant
 *
 * @param {Object} props
 * @param {boolean} props.open - Whether modal is open
 * @param {Function} props.onClose - Handler for closing modal
 * @param {Object} props.packageDetails - Package details from context
 * @param {Object} props.quoteDetails - Quote details
 * @param {number} props.totalPrice - Total price
 * @param {number} props.baggagePrice - Total baggage price
 * @param {number} props.paymentsCount - Number of payments
 * @param {Array} props.passengers - Passengers array
 * @param {string} props.currency - Currency code
 * @param {number} props.currentStep - Current wizard step
 * @param {Array} props.baggageState - Baggage selections
 */
const BookingDetailsModal = ({
  open,
  onClose,
  packageDetails,
  quoteDetails,
  totalPrice,
  baggagePrice = 0,
  paymentsCount = 1,
  passengers = [],
  currency = 'USD',
  currentStep = 1,
  baggageState = []
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      className="booking-details-modal"
      PaperProps={{
        style: {
          borderRadius: '16px 16px 0 0',
          margin: 0,
          /*maxHeight: '80vh',*/
          position: 'fixed',
          bottom: 0
        }
      }}
    >
      {/* Header */}
      <div className="booking-modal-header">
        <div className="booking-modal-title">{t('reservation.modals.bookingDetails.title')}</div>
        <button
          className="booking-modal-close"
          onClick={onClose}
          aria-label={t('reservation.modals.bookingDetails.close')}
        >
          <CloseIcon />
        </button>
      </div>

      {/* Content */}
      <div className="booking-modal-content">
        <BookingDetails
          packageDetails={packageDetails}
          quoteDetails={quoteDetails}
          totalPrice={totalPrice}
          baggagePrice={baggagePrice}
          paymentsCount={paymentsCount}
          passengers={passengers}
          currency={currency}
          currentStep={currentStep}
          baggageState={baggageState}
          variant="modal"
          showPrice={true}
        />
      </div>
    </Dialog>
  );
};

export default BookingDetailsModal;
